import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import "./Profile.css";

export default function Profile() {
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [profile, setProfile] = useState({
    name: "Guest Explorer",
    email: "guest@popx.app",
    company: "Freelance Designer",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80",
  });

  const [tempProfile, setTempProfile] = useState({ ...profile });
  const [notes, setNotes] = useState([
    { id: 1, text: "Explore the new PopX tools" },
    { id: 2, text: "Design system integration" }
  ]);
  const [newNote, setNewNote] = useState("");

  const handleEditToggle = () => {
    if (isEditing) {
      setProfile({ ...tempProfile });
    } else {
      setTempProfile({ ...profile });
    }
    setIsEditing(!isEditing);
  };

  const addNote = () => {
    if (newNote.trim()) {
      setNotes([...notes, { id: Date.now(), text: newNote }]);
      setNewNote("");
    }
  };

  const deleteNote = (id) => {
    setNotes(notes.filter(note => note.id !== id));
  };

  return (
    <div className="dashboard-container">
      {/* Top Navbar */}
      <header className="dashboard-header">
        <div className="header-logo">
          <span className="logo-icon">✦</span> PopX Workspace
        </div>
        <div className="header-actions">
          <span className="badge-free">Free Mode Unlocked</span>
          <Button className="btn-logout" onClick={() => navigate("/")}>
            Exit Workspace
          </Button>
        </div>
      </header>

      {/* Main Grid Layout */}
      <main className="dashboard-grid">
        {/* Profile Card Section */}
        <section className="dashboard-card profile-card-large">
          <div className="card-header">
            <h3>User Profile</h3>
            <button className="edit-btn" onClick={handleEditToggle}>
              {isEditing ? "Save Changes" : "Edit Profile"}
            </button>
          </div>

          <div className="profile-details-layout">
            <div className="profile-avatar-wrapper">
              <img src={profile.avatar} alt="Profile Avatar" className="profile-avatar" />
              {isEditing && (
                <input
                  type="text"
                  placeholder="Paste avatar URL"
                  value={tempProfile.avatar}
                  className="avatar-url-input"
                  onChange={(e) => setTempProfile({ ...tempProfile, avatar: e.target.value })}
                />
              )}
            </div>

            <div className="profile-info-fields">
              {isEditing ? (
                <div className="edit-form">
                  <div className="form-group">
                    <label>Full Name</label>
                    <input
                      type="text"
                      value={tempProfile.name}
                      onChange={(e) => setTempProfile({ ...tempProfile, name: e.target.value })}
                    />
                  </div>
                  <div className="form-group">
                    <label>Email Address</label>
                    <input
                      type="email"
                      value={tempProfile.email}
                      onChange={(e) => setTempProfile({ ...tempProfile, email: e.target.value })}
                    />
                  </div>
                  <div className="form-group">
                    <label>Company/Role</label>
                    <input
                      type="text"
                      value={tempProfile.company}
                      onChange={(e) => setTempProfile({ ...tempProfile, company: e.target.value })}
                    />
                  </div>
                </div>
              ) : (
                <div className="profile-view">
                  <h2 className="profile-name">{profile.name}</h2>
                  <p className="profile-email">✉ {profile.email}</p>
                  <p className="profile-company">💼 {profile.company}</p>
                  <div className="status-indicator">
                    <span className="status-dot"></span> Active Free Session
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Stats Widget */}
        <section className="dashboard-card stats-card">
          <h3>Workspace Status</h3>
          <div className="stats-grid">
            <div className="stat-box">
              <span className="stat-number">100%</span>
              <span className="stat-label">Free Access</span>
            </div>
            <div className="stat-box">
              <span className="stat-number">Unlimited</span>
              <span className="stat-label">Projects</span>
            </div>
            <div className="stat-box">
              <span className="stat-number">$0</span>
              <span className="stat-label">Lifetime Cost</span>
            </div>
          </div>
          <div className="upgrade-banner">
            <h4>No Registration Required</h4>
            <p>You have direct access to all system tools without sign-up or accounts.</p>
          </div>
        </section>

        {/* Quick Notes Widget */}
        <section className="dashboard-card notes-card">
          <h3>Quick Workspace Notes</h3>
          <div className="notes-list">
            {notes.length === 0 ? (
              <p className="empty-notes">No notes yet. Add one below!</p>
            ) : (
              notes.map(note => (
                <div key={note.id} className="note-item">
                  <span className="note-text">{note.text}</span>
                  <button className="note-delete" onClick={() => deleteNote(note.id)}>✕</button>
                </div>
              ))
            )}
          </div>
          <div className="note-input-group">
            <input
              type="text"
              placeholder="Add a quick note..."
              value={newNote}
              onChange={(e) => setNewNote(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && addNote()}
            />
            <Button className="btn-add-note" onClick={addNote}>Add</Button>
          </div>
        </section>

        {/* Features Preview Card */}
        <section className="dashboard-card system-info-card">
          <h3>System Features</h3>
          <ul className="system-features-list">
            <li>
              <strong>✓ Local Saving:</strong> Settings are active for your browser session.
            </li>
            <li>
              <strong>✓ High Security:</strong> Your data never leaves your system. No server tracking.
            </li>
            <li>
              <strong>✓ Interactive Widgets:</strong> Add note components dynamically.
            </li>
          </ul>
        </section>
      </main>
    </div>
  );
}
